<template>
    <v-text-field
        ref="textField"
        :value="value"
        v-bind="$attrs"
        outlined
        :label="computedLabel"
        :error-messages="errorMessages"
        :hide-details="hideDetails"
        :placeholder="placeholder"
        :disabled="disabled"
        :tabindex="tabindex"
        :append-icon="appendIcon"
        @keypress="$emit('keypress', $event)"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
        @blur="$emit('blur', $event)"
        @click:append="$emit('click:append', $event)"
        @click="$emit('click', $event)"
        @focus="$emit('focus', $event)"
        @keyup="$emit('keyup', $event)"
    >
        <template v-if="tooltip" v-slot:append>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        size="21"
                        class="mr-2"
                        v-on="on"
                    >
                        mdi-help-circle-outline
                    </v-icon>
                </template>
                {{ tooltip }}
            </v-tooltip>
        </template>
    </v-text-field>
</template>

<script>
import {computed} from "@vue/composition-api";

export default {
    name: "TextField",
    props: {
        errorMessages: {
            type: [String, Array],
            default: () => []
        },
        bindProps: {
            type: Object,
            default: null
        },
        value: {
            type: [String, Number],
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tabindex: {
            type: [String, Number],
            default: null
        },
        appendIcon: {
            type: String,
            default: null
        },
        tooltip: {
            type: String,
            default: null
        },
        required: {
            type: Boolean,
            default: false
        },
        forceShowDetails: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const hideDetails = computed(() => {
            if (props.forceShowDetails) {
                return false
            }

            if (props.errorMessages && !props.errorMessages.length) {
                return true
            }

            if (props.errorMessages) {
                return false
            }


            if (props.bindProps && props.bindProps.hideDetails) {
                return true
            }

            return true
        })

        const computedLabel = computed(() => {
            let label = props.label

            if (props.required) {
                label += ' *';
            }

            return label
        })

        return {
            hideDetails,
            computedLabel
        }
    }
}
</script>

<style scoped lang="scss">
.v-text-field {
    ::v-deep {
        .v-input__control {
            .v-input__slot {
                .v-input__prepend-inner {
                    margin-top: auto;
                    margin-bottom: auto;
                    margin-right: -8px;
                    margin-left: 8px;
                }
            }
        }
    }
}

.v-text-field {
    ::v-deep {

        .v-input__control {
            .v-input__slot {
                .v-text-field__suffix {
                    padding-right: 8px;
                }
            }
        }
    }
}
</style>
